import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

  const routes = [
    {
      path: "/",
      // name: 'layout',
      component: () => import("../views/layout"),
      children: [
        {
          path: "/refund-detail",
          name: "refund-detail",
          component: () => import("../views/home/refund-detail.vue"),
        },
        {
          path: "/",
          name: "Home",
          component: () => import("../views/home/index.vue"),
        },
        {
        path: "/pharmacist-course", // 执业药师继续教育课程选择
        name: "pharmacist-course",
        component: () => import("../views/pharmacist-course/pharmacist-course"),
      },
        {
          path: "/Coursetobuy", // 课程详情
          name: "Coursetobuy",
          component: () => import("../views/home/Coursetobuy"),
        },
        {
          path: "/Purchase", // 购买课程
          name: "Purchase",
          component: () => import("../views/home/Purchase"),
        },
        {
          path: "/personal", // 个人中心
          name: "personal",
          component: () => import("../views/personal"),
        },
        {
          path: "/Gostudy", // 视频详情
          name: "Gostudy",
          component: () => import("../views/home/Gostudy"),
        },
        {
          path: "/GostudyList", // 视频详情
          name: "GostudyList",
          component: () => import("../views/home/Gostudy/list"),
        },
        {
          path: "/PublicList", // 视频详情
          name: "PublicList",
          component: () => import("../views/home/Public/list"),
        },
        {
          path: "/PublicBuy", // 视频详情
          name: "PublicBuy",
          component: () => import("../views/home/Public/buy"),
        },
        {
          path: "/PublicVideo", // 视频详情
          name: "PublicVideo",
          component: () => import("../views/home/Public/video"),
        },
        {
          path: "/contact", // 随堂练习
          name: "contact",
          component: () => import("../views/home/contact"),
        },
        {
          path: "/okTest", // 随堂练习 分数
          name: "okTest",
          component: () => import("../views/home/okTest"),
        },
        {
          path: "/teacher", // 名师风采  详情
          name: "teacher",
          component: () => import("../views/home/teacher"),
        },
        {
          path: "/teacher-detail", // 名师风采  详情
          name: "teacher",
          component: () => import("../views/home/teacher/detail"),
        },
        {
          path: "/journalism", // 行业资讯
          name: "journalism",
          component: () => import("../views/home/journalism"),
        },
        {
          path: "/classify", // 课程分类
          name: "classify",
          component: () => import("../views/home/classify/classify.vue"),
        },
        {
          path: "/detailss", // 资讯详情
          name: "detailss",
          component: () => import("../views/home/journalism/detailss"),
        },
        {
          path: "/new-detail", // 资讯详情
          name: "new-detail",
          component: () => import("../views/home/news/new-detail"),
        },
        {
          path: "/help", // 帮助中心
          name: "help",
          component: () => import("../views/home/help"),
        },
        {
          path: "/issue", // 开具发票
          name: "issue",
          component: () => import("../views/home/help/issue"),
        },
        {
          path: "/AboutUs", // 关于我们
          name: "AboutUs",
          component: () => import("../views/home/AboutUs"),
        },
        {
          path: "/succeed", // 支付成功
          name: "succeed",
          component: () => import("../views/home/succeed"),
        },
        // {
        //   path: "/Golearn", // 开始学习
        //   name: "Golearn",
        //   component: () => import("../views/home/Golearn"),
        // },
        {
          path: "/simulativeTset", // 模拟练习
          name: "simulativeTset",
          component: () => import("../views/home/Golearn/simulativeTset"),
        },
        {
          path: "/kaoshi", // 模拟练习
          name: "kaoshi",
          component: () => import("../views/home/Golearn/simulativeTset/list"),
        },
        {
          path: "/purchases", // 购买试题
          name: "purchases",
          component: () => import("../views/home/Golearn/purchases"),
        },
        {
          path: "/test", // 模拟测试
          name: "test",
          component: () => import("../views/home/Golearn/test"),
        },
        {
          path: "/lianxi", // 模拟测试
          name: "lianxi",
          component: () => import("../views/home/Golearn/test/list"),
        },
        {
          path: "/fulfillTest", // 随堂练习结果
          name: "fulfillTest",
          component: () => import("../views/home/Golearn/fulfillTest"),
        },
      ]
    },
  {
    path: '/pharmacist', // 执业药师继续教育登录入口
    name: 'pharmacist',
        component: () => import(/* webpackChunkName: "about" */ '@/views/login/pharmacist')
  },
  {
    path: '/purchase', // 购买课程
    name: 'purchase',
        component: () => import(/* webpackChunkName: "about" */ '@/views/login/purchase')
  },
  {
    path: '/paymentOk', // 支付成功
    name: 'paymentOk',
        component: () => import(/* webpackChunkName: "about" */ '@/views/login/paymentOk')
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/home/help/privacy.vue"),
  },
]

const router = new VueRouter({
  routes
})

export default router
